import {
   LocationOption,
   PastAppointmentSortByOptions,
} from "../../../../consts";
export const defaultSortedBy: PastAppointmentSortByOptions =
   PastAppointmentSortByOptions.Chronological;
export const defaultLocationVal: string = LocationOption.ALL;
export const defaultAppointmentTypes = [];
export const defaultDonorStatus = [];
